import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/today/page.tsx");
